import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cfb6f18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "innerContainer" }
const _hoisted_2 = { class: "usersList" }
const _hoisted_3 = {
  key: 0,
  class: "divider"
}
const _hoisted_4 = { class: "userContainer" }
const _hoisted_5 = { class: "userName" }
const _hoisted_6 = { class: "buttons" }

import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import { useGetChatSettingsCommonProperties } from "../useGetChatSettingsCommonProperties";
import { User } from "@/store/users/state";
import Icon from "@/components/icons/Icon/Icon.vue";
import ProfileImage from "@/components/images/ProfileImage.vue";
import { IconType } from "@/types/icons";
import GenericButton from "@/components/buttons/GenericButton.vue";
import InfoModal from "@/components/modals/InfoModal.vue";
import { reactive, computed } from "vue";
import { store } from "@/store";
import { AllActionTypes } from "@/store/actionTypes";
import { GenericButtonVariantEnum } from "@/types/button";
interface StateProps {
  members: User[];
  membersForRemove: User[];
  isModalShown: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsShowGroupUsers',
  setup(__props) {

const { selectedChatId, route, router, getters } =
  useGetChatSettingsCommonProperties();

const chatId = computed<string>(
  () => selectedChatId.value ?? (route.params.chat_id as string),
);

const chatDetail = computed(() =>
  getters.GET_CONVERTED_CHAT_DETAIL(chatId.value),
);

const membersList = computed<User[] | undefined>(() => {
  return chatDetail.value.members;
});

const state: StateProps = reactive({
  members: [...(membersList.value || [])],
  membersForRemove: [],
  isModalShown: false,
});

const removeMember = (id: number, member: User) => {
  state.membersForRemove.push(member);
  state.members = state.members.filter((obj) => obj.id !== id);
};

const saveChanges = () => {
  const removeMemberIds = state.membersForRemove.map((m) => m.id).map(String);

  store.dispatch(AllActionTypes.UPDATE_GROUP_CHAT_MEMBERS, {
    chatId: chatId.value,
    removeMemberIds,
  });
  router.push(`/${chatDetail.value.id}`);
};

const redirect = () => {
  if (state.membersForRemove.length === 0 || state.isModalShown) {
    return router.replace(`/settings/chat/${chatDetail.value.id}`);
  }
  state.isModalShown = true;
};
const closeModal = () => {
  state.isModalShown = false;
};

const handleAction = async () => {
  await router.replace(`/settings/chat/add_users_to_group/${chatId.value}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, {
    "handle-redirect": redirect,
    title: _ctx.$t('settings.chat.showUsers.subtitle'),
    "handle-action": handleAction,
    "action-title": _ctx.$t('settings.chat.showUsers.addUser')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.members, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: user.id,
              class: "user"
            }, [
              (index !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(ProfileImage, {
                  id: user.id,
                  image: user.picture,
                  size: 48,
                  class: "profileImg"
                }, null, 8, ["id", "image"]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(user.name), 1),
                _createVNode(Icon, {
                  icon: _unref(IconType).TRASH,
                  class: "deleteIcon",
                  onClick: ($event: any) => (removeMember(user.id, user))
                }, null, 8, ["icon", "onClick"])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(GenericButton, {
            variant: _unref(GenericButtonVariantEnum).Primary,
            text: "settings.chat.showUsers.options.save",
            onClick: saveChanges
          }, null, 8, ["variant"]),
          _createVNode(GenericButton, {
            variant: _unref(GenericButtonVariantEnum).Secondary,
            text: "settings.chat.showUsers.options.cancel",
            onClick: redirect
          }, null, 8, ["variant"])
        ])
      ]),
      (state.isModalShown)
        ? (_openBlock(), _createBlock(InfoModal, {
            key: 0,
            title: "settings.chat.showUsers.redirectModal.title",
            label: "settings.chat.showUsers.redirectModal.label",
            "btn-text": "settings.chat.showUsers.redirectModal.save",
            "cancel-btn-text": "settings.chat.showUsers.redirectModal.cancel",
            "save-action": saveChanges,
            "cancel-action": redirect,
            "close-action": closeModal
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "action-title"]))
}
}

})